/*-
 * ========================LICENSE_START=================================
 * TeamApps
 * ---
 * Copyright (C) 2014 - 2025 TeamApps.org
 * ---
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * 
 *      http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =========================LICENSE_END==================================
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;

import {UiCommand} from "./UiCommand";
import {UiEvent} from "./UiEvent";
import {UiQuery} from "./UiQuery";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiFieldConfig} from "./UiFieldConfig";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiClientObjectConfig} from "./UiClientObjectConfig";
import {UiFieldMessageConfig} from "./UiFieldMessageConfig";
import {UiDateTimeFormatDescriptorConfig} from "./UiDateTimeFormatDescriptorConfig";
import {UiLocalDateConfig} from "./UiLocalDateConfig";
import {UiFieldCommandHandler} from "./UiFieldConfig";
import {UiFieldEventSource} from "./UiFieldConfig";

export enum UiLocalDateField_DropDownMode {
	CALENDAR, CALENDAR_SUGGESTION_LIST, SUGGESTION_LIST
}

export interface UiLocalDateFieldConfig extends UiFieldConfig {
	_type?: string;
	showDropDownButton?: boolean;
	showClearButton?: boolean;
	favorPastDates?: boolean;
	locale?: string;
	dateFormat?: UiDateTimeFormatDescriptorConfig;
	defaultSuggestionDate?: UiLocalDateConfig;
	shuffledFormatSuggestionsEnabled?: boolean;
	dropDownMode?: UiLocalDateField_DropDownMode;
	placeholderText?: string;
	calendarIconEnabled?: boolean
}

export interface UiLocalDateFieldCommandHandler extends UiFieldCommandHandler {
	update(config: UiLocalDateFieldConfig): any;
}

export interface UiLocalDateFieldEventSource extends UiFieldEventSource {
}


